// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../Contexts/AuthContext';

// const AllowAccessTo = ({ permissions, redirectTo, children }) => {
//   const navigate = useNavigate();
//   const { status } = useAuth();
//   const userPermissions = (status && status.permissions) || [];

//   // Ensure permissions is an array
//   const allowedPermissions = typeof permissions === 'string' ? [permissions] : permissions;

//   // Check if user has at least one of the allowed permissions
//   const isAllowed = allowedPermissions.some(perm => userPermissions.includes(perm));

//   // Determine if the user should be able to edit:
//   // If the user holds any allowed permission that starts with "all:" or "edit:" then canEdit is true.
//   const canEdit = allowedPermissions.some(perm =>
//     userPermissions.includes(perm) && (perm.startsWith('all:') || perm.startsWith('edit:'))
//   );

//   // If the user is not allowed and redirectTo is provided, redirect
//   useEffect(() => {
//     if (!isAllowed && redirectTo) {
//       navigate(redirectTo);
//     }
//   }, [isAllowed, redirectTo, navigate]);

//   // If not allowed and a redirect is in place, render nothing (redirection will occur)
//   if (!isAllowed && redirectTo) {
//     return null;
//   }

//   // If not allowed and no redirect is provided, show an access denied message
//   if (!isAllowed) {
//     return <div>Access Denied</div>;
//   }

//   // Clone the child element and add the `canEdit` prop
//   return React.cloneElement(children, { canEdit });
// };

// export default AllowAccessTo;

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';

const AllowAccessTo = ({ permissions, redirectTo, children }) => {
  const navigate = useNavigate();
  const { status } = useAuth();

  // Check if the API call is still in progress
  const isLoading = status.status === 'connecting';

  // Use an empty array as fallback for permissions
  const userPermissions = status.permissions || [];
  const allowedPermissions = typeof permissions === 'string' ? [permissions] : permissions;
  const isAllowed = allowedPermissions.some((perm) => userPermissions.includes(perm));

  // Determine if the user can edit
  const canEdit = allowedPermissions.some(
    (perm) =>
      userPermissions.includes(perm) && (perm.startsWith('all:') || perm.startsWith('edit:')),
  );

  // Always call the hook but only navigate if not loading
  useEffect(() => {
    if (!isLoading && !isAllowed && redirectTo) {
      navigate(redirectTo);
    }
  }, [isLoading, isAllowed, redirectTo, navigate]);

  // Now conditionally render based on the loading and authorization status
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAllowed && redirectTo) {
    return null;
  }

  if (!isAllowed) {
    return <div>Access Denied</div>;
  }

  // Render the child component and pass the `canEdit` prop
  return React.cloneElement(children, { canEdit });
};

export default AllowAccessTo;
